import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import Loader from '../../../safreeimg/loader.gif'
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png'

const TrackPayment = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const rowsPerPage = 10;
  const navigate = useNavigate(); 
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        const hash = window.location.hash.substring(1); 
        if (!hash) {
          setError('No ID found in the URL hash');
          setLoading(false);
          return;
        }

        console.log('Extracted ID:', hash);
        console.log('Token:', token); 

        // API Call
        const response = await axios.get(
          `https://api.safree.org/api-v2022/superAdmin/auth/v1/users-i-am-guarding/${hash}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, 
              'Content-Type': 'application/json',
            },
          }
        );

        console.log('API Response:', response);

        if (response.data && Array.isArray(response.data.data)) {
          setUsers(response.data.data);
        } else {
          setError('Invalid data format from API');
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('An error occurred while fetching users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const totalPages = Math.ceil(users.length / rowsPerPage);

  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;

  if (error) return <div>Error: {error}</div>;
  const handleBackClick = () => {
    navigate(-1);  
  };
  return (
    <div className="container user-management">
      {/* Header Section */}
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading"><img  onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />Track Payments and Billing</p>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Name</th>
              <th>Phone Number</th>
              <th>Purchase Date</th>
              <th>Expire Date</th>
              <th>Plan</th>
              <th>Pay Amount</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((user, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>Anshul Sharma</td>
                <td>88887744444</td>
                <td>27-12-2024</td>
                <td>27-12-2025</td>
                <td>Month</td>
                <td>20$</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Section */}
        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackPayment;
